/**
 * Projects Page
 * Project management for timesheet tracking
 * Route: /apps/timesheet/projects
 */

import React from 'react';
import { UniversalTable } from '@/components/features/udc/UniversalTable';
import { Tag } from 'antd';

export const ProjectsPage: React.FC = () => {
  return (
    <UniversalTable
      collection="timesheet/projects"
      title="Projects"
      searchPlaceholder="Search projects..."
      customRenderers={{
        // Custom renderer for project status
        status: (value) => {
          const colors: Record<string, string> = {
            active: 'green',
            completed: 'blue',
            on_hold: 'orange',
            cancelled: 'red',
          };
          return (
            <Tag color={colors[value] || 'default'}>
              {value?.replace('_', ' ').toUpperCase()}
            </Tag>
          );
        },
        // Custom renderer for budget
        budget: (value) => {
          if (!value) return '-';
          return new Intl.NumberFormat('sr-RS', {
            style: 'currency',
            currency: 'RSD',
            minimumFractionDigits: 0,
          }).format(value);
        },
        // Custom renderer for project name (make it bold)
        name: (value) => (
          <span style={{ fontWeight: 600, color: 'var(--primary-color)' }}>
            {value}
          </span>
        ),
      }}
    />
  );
};
